import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Webcam = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Webcam" {...props}>
    <path d="M16 3C19.866 3 23 6.13401 23 10C23 13.866 19.866 17 16 17H15V21H16C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23H8C7.44772 23 7 22.5523 7 22C7 21.4477 7.44772 21 8 21H9V17H8C4.13401 17 1 13.866 1 10C1 6.13401 4.13401 3 8 3H16ZM11 21H13V17H11V21ZM8 5C5.23858 5 3 7.23858 3 10C3 12.7614 5.23858 15 8 15H16C18.7614 15 21 12.7614 21 10C21 7.23858 18.7614 5 16 5H8ZM12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8Z" fill="#000" />
  </StyledIcon>
));

Webcam.displayName = 'Webcam';

export { Webcam };
